import axios from 'axios'
import { BREVO_API_KEY, expressURL } from '../../../../../services/api'
import { addSystemLog } from '../../../../PlantBusinessView/components/InvoiceBill/utils/invoiceApi'

// Brevo API key and email configurations

const SENDER_EMAIL = 'info@de.energy' // Updated sender email for investor notifications

const getEmailTemplate = (type, userData) => {
  const commonStyles = `
  body { font-family: Roboto; line-height: 1.6; margin: 0; padding: 0; color: #202124; }
  .email-container { max-width: 600px; margin: 0 auto; padding: 20px; } /* No border as requested */
  .logo { padding: 20px 0; border-bottom: 1px solid #dadce0; }
  .content { padding: 20px 0; }
  h1 { font-size: 34px; color:rgb(0, 0, 0); margin-bottom: 5px; } /* Increased size for heading */
  .blue-text { color: #1a73e8; }
  p { font-size: 14px; color: #5f6368; margin: 10px 0; }
  .highlight { background-color: #f8f9fa; padding: 15px; border-radius: 4px; margin: 15px 0; }
  ul { padding-left: 20px; }
  li { margin-bottom: 10px; font-size: 14px; color: #5f6368; }
  .button { display: inline-block; padding: 8px 24px; background-color: #1a73e8; color: black; text-decoration: none; border-radius: 4px; font-weight: bold; margin: 15px 0; }
  .footer { margin-top: 30px; padding-top: 20px; border-top: 1px solid #dadce0; font-size: 12px; color: #5f6368; }
  .info-icon { color: #1a73e8; width: 24px; height: 24px; vertical-align: middle; } /* Updated for image icon */
  .need-help-text { font-size: 24px; font-weight: bold; color: #202124; margin: 10px 0; } /* Larger, bold "Need help?" */
`

  const templates = {
    investor: {
      subject: 'Welcome to the Distributed Energy Monitoring Dashboard',
      htmlContent: `
      <!DOCTYPE html>
      <html>
      <head>
        <style>${commonStyles}</style>
      </head>
      <body>
        <div class="email-container">
          <div class="logo">
            <img src="https://de-dashboard.hostwire.cloud/static/media/DE_logo.607cf5fcc36ce7ad0909.png" alt="Distributed Energy Logo" height="24" />
          </div>
          
          <div class="content">
            <h1>Keep your Energy Portfolio <br><span class="blue-text">monitored and optimized</span></h1> 
            
            <p>Dear ${userData.name},</p>
            
            <p>Welcome to the Distributed Energy Monitoring Dashboard! We are pleased to provide you with access to real-time performance data for the solar plants you have invested in.</p>
            
            <div class="highlight">
              <p><strong>You can log in using the credentials below:</strong></p>
              <p>Username: ${userData.username || userData.email}</p>
              <p>Password: ${
                userData.password || '[Your temporary password]'
              }</p>
              
              <a href="https://staging-frontend-v3.de.energy/" style="display: inline-block; padding: 8px 24px; background-color: #1a73e8; color: white; text-decoration: none; border-radius: 4px; font-weight: bold; margin: 15px 0;">View My Solar Portfolio</a>

            </div>


            <p><strong>Important reminders:</strong></p>
            <ul>
            <li>Once logged in, you will be able to monitor key performance metrics, including energy generation and system efficiency.</li>
            
            <li><strong>For security reasons, we recommend changing your password upon first login.</strong></li>
            
           <li>Thank you for your investment in clean energy. We look forward to keeping you updated on your solar portfolio's performance.</li>
            </ul>
            <div style="margin-top: 30px;">
              <p>
                <img src="https://ci3.googleusercontent.com/meips/ADKq_NayBQMbe_9ifzRO2A25JCDbAgpOXn6aBvuM-mtVahkucnZOsqhyL0ebE9lpKOjK8YVaB5cRpADjzuvqRZC8Nkfw8Cbu02qwJqZa5vJRTDpzUsM0-rgSIoyT-f5H4Wl_hgyL7wHKF_TstvU4VDSdCR_9_twz=s0-d-e1-ft#https://www.gstatic.com/gumdrop/files/merchant-center-icon-info-transparent-w96px-h96px-2x.png"   alt="Info Icon" class="info-icon" />
                 <br>
                <span class="need-help-text">Need help?</span> <!-- Bold and larger "Need help?" -->
              </p>
              <p>If you have any questions or need assistance, please feel free to reach out to us at <a href="mailto:info@de.energy" style="color: #1a73e8; text-decoration: none;">info@de.energy</a>.</p>
            </div>
          </div>
          
    <div style="background-color: #f8f9fa; padding: 20px; border-top: 1px solid #dadce0;">
    <img src="https://de-dashboard.hostwire.cloud/static/media/DE_logo.607cf5fcc36ce7ad0909.png" alt="Distributed Energy Logo" height="36" style="vertical-align: middle; margin-right: 15px;" />
    <div style="display: inline-block; vertical-align: middle; margin-left: 15px; border-left: 1px solid #dadce0; padding-left: 15px;">
      <p style="margin: 0; font-size: 12px; color: #5f6368;">
        © ${new Date().getFullYear()} Distributed Energy Pte Ltd<br/>
        101 Cecil Street, #11-10, Tong Eng Building,<br/>
        Singapore – 069533<br/>
        <a href="info@de.energy" style="color: #1a73e8; text-decoration: none;">info@de.energy</a>
      </p>
    </div>
  </div>
        </div>
      </body>
      </html>
    `,
    },
    client: {
      subject:
        'Welcome to Distributed Energy - Your Solar System Management Portal',
      htmlContent: `
      <!DOCTYPE html>
      <html>
      <head>
        <style>${commonStyles}</style>
      </head>
      <body>
        <div class="email-container">
          <div class="logo">
            <img src="https://de-dashboard.hostwire.cloud/static/media/DE_logo.607cf5fcc36ce7ad0909.png" alt="Distributed Energy Logo" height="24" />
          </div>
          
          <div class="content">
            <h1>Manage and Monitor your <br><span class="blue-text">Solar Energy System</span></h1> 
            
            <p>Dear ${userData.name},</p>
            
            <p>Welcome to Distributed Energy! We're excited to provide you with comprehensive monitoring and management tools for your solar energy system. Your account has been successfully created.</p>
            
            <div class="highlight">
              <p><strong>You can access your solar system dashboard using these credentials:</strong></p>
              <p>Username: ${userData.username || userData.email}</p>
              <p>Password: ${
                userData.password || '[Your temporary password]'
              }</p>
              
              <a href="https://staging-frontend-v3.de.energy/" style="display: inline-block; padding: 8px 24px; background-color: #1a73e8; color: white; text-decoration: none; border-radius: 4px; font-weight: bold; margin: 15px 0;">Access My Solar Dashboard</a>

            </div>

            <p><strong>What you can do with your dashboard:</strong></p>
            <ul>
              <li>Monitor real-time energy production and consumption data</li>
              <li>Track your system's performance and efficiency metrics</li>
              <li>View historical data and energy generation trends</li>
              <li>Receive alerts and notifications about system status</li>
              <li>Access detailed reports for maintenance and optimization</li>
            </ul>

            <p><strong>Getting started:</strong></p>
            <ul>
              <li><strong>Please change your password upon first login for security purposes.</strong></li>
              <li>Explore the dashboard features to familiarize yourself with the interface.</li>
              <li>Set up your notification preferences to stay informed about your system.</li>
              <li>Contact our support team if you need assistance with any features.</li>
            </ul>

            <div style="margin-top: 30px;">
              <p>
                <img src="https://ci3.googleusercontent.com/meips/ADKq_NayBQMbe_9ifzRO2A25JCDbAgpOXn6aBvuM-mtVahkucnZOsqhyL0ebE9lpKOjK8YVaB5cRpADjzuvqRZC8Nkfw8Cbu02qwJqZa5vJRTDpzUsM0-rgSIoyT-f5H4Wl_hgyL7wHKF_TstvU4VDSdCR_9_twz=s0-d-e1-ft#https://www.gstatic.com/gumdrop/files/merchant-center-icon-info-transparent-w96px-h96px-2x.png"   alt="Info Icon" class="info-icon" />
                 <br>
                <span class="need-help-text">Need help?</span>
              </p>
              <p>Our technical support team is here to assist you. For any questions, system issues, or technical support, please contact us at <a href="mailto:info@de.energy" style="color: #1a73e8; text-decoration: none;">info@de.energy</a>.</p>
            </div>
          </div>
          
          <div style="background-color: #f8f9fa; padding: 20px; border-top: 1px solid #dadce0;">
            <img src="https://de-dashboard.hostwire.cloud/static/media/DE_logo.607cf5fcc36ce7ad0909.png" alt="Distributed Energy Logo" height="36" style="vertical-align: middle; margin-right: 15px;" />
            <div style="display: inline-block; vertical-align: middle; margin-left: 15px; border-left: 1px solid #dadce0; padding-left: 15px;">
              <p style="margin: 0; font-size: 12px; color: #5f6368;">
                © ${new Date().getFullYear()} Distributed Energy Pte Ltd<br/>
                101 Cecil Street, #11-10, Tong Eng Building,<br/>
                Singapore – 069533<br/>
                <a href="info@de.energy" style="color: #1a73e8; text-decoration: none;">info@de.energy</a>
              </p>
            </div>
          </div>
        </div>
      </body>
      </html>
    `,
    },
  }

  return templates[type.toLowerCase()]
}


const sendWelcomeEmail = async (userData) => {
  const BREVO_API_URL = 'https://api.brevo.com/v3/smtp/email'

  try {
    var getUserId = localStorage.getItem('userId')
    // Load CC recipients dynamically from Email Settings (welcome-emails)
    let ccList = []
    try {
      const emailId = 'welcome-emails'
      const res = await axios.get(`${expressURL}/api/email-settings/${emailId}`)
      const settingsCc = res?.data?.cc
      if (Array.isArray(settingsCc)) {
        ccList = settingsCc
          .filter((r) => r && r.email)
          .map((r) => ({ email: r.email, name: r.name || 'CC' }))
      }
    } catch (e) {
      // If fetching CC fails, proceed without CC
      ccList = []
    }
    const template = getEmailTemplate(userData.type, userData)

    const emailData = {
      sender: {
        email: SENDER_EMAIL,
        name: 'Distributed Energy',
      },
      to: [
        {
          email: userData.email,
          name: userData.name,
        },
      ],
      cc: ccList,
      subject: template.subject,
      htmlContent: template.htmlContent,
    }

    const response = await fetch(BREVO_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'api-key': BREVO_API_KEY,
      },
      body: JSON.stringify(emailData),
    })

    if (response.status === 429) {
      throw new Error('Rate limit exceeded. Please try again later.')
    }

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Failed to send email')
    }

    // Log successful welcome email sending
    await addSystemLog({
      userId: getUserId || null, // Assuming userData has userId
      activity: 'Welcome Email Sent',
      details: `Welcome email sent successfully to ${userData.email}`,
      changes: {
        emailType: 'Welcome',
        recipientEmail: userData.email,
        recipientName: userData.name,
        userType: userData.type,
        subject: template.subject,
        ccRecipients: (emailData.cc || []).map((c) => c.email),
      },
      plantName: userData.plantName || null,
      plantId: userData.plantId || null,
    })

    return {
      success: true,
      message: `Welcome email sent successfully to ${userData.email}`,
    }
  } catch (error) {
    console.error('Error sending welcome email:', error)

    // Log failed welcome email attempt
    await addSystemLog({
      userId: getUserId || null,
      activity: 'Welcome Email Failed',
      details: `Failed to send welcome email to ${userData.email}: ${error.message}`,
      changes: {
        emailType: 'Welcome',
        recipientEmail: userData.email,
        error: error.message,
        userType: userData.type,
      },
      plantName: userData.plantName || null,
      plantId: userData.plantId || null,
    })

    return {
      success: false,
      error: error.message,
    }
  }
}

export { sendWelcomeEmail }
